<template>
  <div class="info-manage-purchaser">
    <div class="info-tabs">
      <el-tabs v-model="activeTab">
        <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.label" :name="item.name">
          <span slot="label">{{ item.label }}</span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="bar-line"></div>
    <div class="order-list" @scroll="handleScroll" v-if="orderList.length != 0">
      <div class="order-card" v-for="(item, index) in orderList" :key="index">
        <!-- 顶部信息栏 -->
        <div class="card-header">
          <div class="header-left">
            <span class="header-id">ID：{{ item.demandId }}</span>
            <span class="header-divider">|</span>
            <span class="header-deadline">验样截止时间：{{ item.verifyEndTime }}</span>
          </div>
          <div class="header-status blue" v-if="item.demandStatus == 'release'">验样收集阶段</div>
          <div class="header-status blue" v-if="item.demandStatus == 'bidding'">竞价对比阶段</div>
          <div class="header-status blue" v-if="item.demandStatus == 'wait_order'">待发起订单</div>
          <div class="header-status blue" v-if="item.demandStatus == 'repurchase_bidding'">复购竞价阶段</div>
          <div class="header-status grey" v-if="item.demandStatus == 'completed'">已完成</div>
          <div class="header-status grey" v-if="item.demandStatus == 'close'">已终止</div>
        </div>
        <!-- 卡片主体 -->
        <div class="card-body">
          <div class="product-name">
            <span class="label">产品名称：</span>
            <span class="value strong">{{ item.productName }}</span>
          </div>
          <div class="product-row">
            <span class="label">产品分类：</span>
            <span class="value">{{ item.productType }}</span>
          </div>
          <div class="product-row">
            <span class="label">备注：</span>
            <span class="value">{{ item.productRemark }}</span>
          </div>
          <div class="product-row" style="margin-top: 10px; color: #333333">
            <span>验样人员：</span>
            <span>-</span>
          </div>
        </div>
        <!-- 底部操作栏 -->
        <div class="card-footer">
          <div class="footer-left">
            <span class="footer-text">待你审核验样：</span>
            <span class="footer-link" @click="goOrder(item.demandId)">{{ item.applyVerifyCount }}条消息 &gt;</span>
          </div>
          <div class="footer-right">
            <button class="action-btn" @click="handleDeleteDemand(item)">删除</button>
            <!-- <button class="action-btn" v-if="item.demandStatus == 'release' || item.demandStatus == 'wait_order' || item.demandStatus == 'bidding'" @click="openTerminateDialog(item)">终止招标</button>
            <button class="action-btn" v-if="item.demandStatus == 'release' && item.applyVerifyCount != '0'" @click="finishVerifyEndFun(item.demandId)">结束验样</button>
            <button class="action-btn" v-if="item.demandStatus == 'wait_order'" @click="openCreateOrderDialog(item)">发起订单</button>
            <button class="action-btn" v-if="item.demandStatus == 'completed'" @click="openCreateOrderDialog(item)">发起复购订单</button> -->
            <button class="action-btn" @click="goOrder(item.demandId)">详情</button>
          </div>
        </div>
      </div>
      <div class="loading-more">
        <span v-if="loadingMore">加载中...</span>
        <span v-else-if="noMore">— 没有更多了 —</span>
      </div>
    </div>
    <div v-else>
      <el-empty description="没有更多数据"></el-empty>
    </div>

    <!-- 终止招标确认弹窗 -->
    <ResultDialog
      :visible.sync="showTerminateDialog"
      title="终止招标提示"
      subtitle="你确定要终止招标吗？"
      :icon-src="require('@/assets/image/question-mark.png')"
      :dialog-width="'420px'"
      confirm-text="确定"
      cancel-text="取消"
      @confirm="handleTerminateConfirm"
      @cancel="showTerminateDialog = false"
      @close="closeTerminateDialog"
      btnMarginTop="35px"
    >
      <template #default>
        <div style="padding: 0 23px">
          <el-input resize="none" style="font-family: initial; font-size: 16px" type="textarea" :rows="6" placeholder="请输入终止理由" v-model="terminateReason"> </el-input>
        </div>
      </template>
    </ResultDialog>

    <!-- 发起订单弹窗 -->
    <el-dialog
      top="8vh"
      :append-to-body="true"
      :visible.sync="showCreateOrderDialog"
      width="808px"
      :show-close="false"
      :close-on-click-modal="false"
      custom-class="publish-demand-dialog"
      @close="handleCloseCreateOrderDialog"
    >
      <div class="publish-modal">
        <img class="publish-close-btn" src="@/assets/image/close1-icon.png" @click="showCreateOrderDialog = false" />
        <h3 class="publish-title">发起订单</h3>
        <div class="publish-form">
          <div class="form-item">
            <span class="form-label">产品名称<i class="required-star">*</i></span>
            <el-input v-model="orderForm.productName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">产品类别<i class="required-star">*</i></span>
            <el-select v-model="orderForm.productTypeId" placeholder="请选择" class="form-select" @change="productTypeIdChange">
              <!-- <el-option v-for="item in productTypes" :key="item.value" :label="item.label" :value="item.value" /> -->
              <el-option v-for="item in productTypeList" :key="item.productTypeId" :label="item.typeName" :value="item.productTypeId" />
            </el-select>
          </div>
          <div class="form-item">
            <span class="form-label">数量</span>
            <el-input type="number" v-model="orderForm.number" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系人</span>
            <el-input v-model="orderForm.relationName" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">联系方式<i class="required-star">*</i></span>
            <el-input v-model="orderForm.relationPhone" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">交货期限</span>
            <el-date-picker v-model="orderForm.deliveryTime" type="date" placeholder="请选择" class="form-date" value-format="yyyy-MM-dd" />
          </div>
          <div class="form-item">
            <span class="form-label">付款方式</span>
            <el-input v-model="orderForm.payMethod" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label">产品质量</span>
            <el-input v-model="orderForm.productQuality" placeholder="请输入" class="form-input" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">产品图片</span>
            <ImageUpload v-model="orderForm.productPicture" :multiple="true" :limit="9" size="120px" dir="product" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">订单信息</span>
            <el-input v-model="orderForm.orderInfo" type="textarea" placeholder="请输入订单信息" class="form-textarea" :rows="4" />
          </div>
          <div class="form-item">
            <span class="form-label" style="line-height: 40px">备注</span>
            <el-input :maxlength="1000" show-word-limit v-model="orderForm.orderRemark" type="textarea" placeholder="说点详细信息吧" class="form-textarea" :rows="4" />
          </div>
          <div v-if="currentDemandStatus == 'completed'" style="text-align: center; color: #ff0000">*将会向本次需求订单通过验样的所有供应商发起复购竞价申请</div>
        </div>

        <div style="text-align: center">
          <button class="publish-submit-btn" @click="submitCreateOrder">发起订单</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getMyDemandList, finishVerifyEnd, removeDemand, closeDemand, createDemandOrder, getProductTypeList } from "@/api/demand";
import { getDictData } from "@/api";
import ResultDialog from "@/components/ResultDialog.vue";
import ImageUpload from "@/components/ImageUpload.vue";
export default {
  name: "InfoManagePurchaser",
  components: {
    ResultDialog,
    ImageUpload,
  },
  data() {
    return {
      activeTab: "",
      loading: false,
      orderList: [],
      pageNum: 1,
      pageSize: 4,
      noMore: false,
      loadingMore: false,
      tabList: [
        { name: "all", label: "全部" },
        { name: "release", label: "验样阶段" },
        { name: "wait_order", label: "待发起订单" },
        { name: "bidding", label: "竞价阶段" },
        { name: "repurchase_bidding", label: "复购竞价" },
        { name: "completed", label: "已完成" },
        { name: "close", label: "已终止" },
      ],
      // 终止招标
      showTerminateDialog: false,
      terminateReason: "",
      currentDemandId: null,
      currentDemandStatus: "",
      // 发起订单
      showCreateOrderDialog: false,
      orderForm: {
        demandId: "",
        productName: "",
        productType: "",
        productTypeId: "",
        number: "",
        relationName: "",
        relationPhone: "",
        deliveryTime: "",
        payMethod: "",
        productQuality: "",
        productPicture: [],
        orderInfo: "",
        orderRemark: "",
      },
      productTypes: [],
      productTypeList: [],
    };
  },
  mounted() {
    if (this.$route.query.route) {
      this.activeTab = this.$route.query.route;
    } else {
      this.activeTab = "all";
    }
    // this.fetchDict();
    this.getProductTypeListFun();
  },
  methods: {
    productTypeIdChange(id) {
      this.productTypeList.forEach((item) => {
        if (item.productTypeId == id) {
          this.orderForm.productType = item.typeName;
        }
      });
    },

    getProductTypeListFun() {
      getProductTypeList().then((res) => {
        this.productTypeList = res.rows;
      });
    },

    async getMyDemandListFun(type) {
      const isFirstPage = this.pageNum === 1;
      if (isFirstPage) {
        this.loading = true;
      } else {
        this.loadingMore = true;
      }
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      if (type !== "all") {
        params.demandStatus = type;
      }
      const res = await getMyDemandList(params);
      if (res.code == 200) {
        this.loading = false;
        this.loadingMore = false;
        if (isFirstPage) {
          this.orderList = res.rows;
        } else {
          this.orderList = this.orderList.concat(res.rows);
        }
        this.noMore = res.rows.length < this.pageSize;
      }
    },
    handleScroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      if (scrollTop + clientHeight >= scrollHeight - 10 && !this.loadingMore && !this.noMore) {
        this.pageNum++;
        this.getMyDemandListFun(this.activeTab);
      }
    },
    goOrder(id) {
      this.$router.push(`/demand-detail/${id}`);
    },
    finishVerifyEndFun(demandId) {
      this.$confirm("确定要结束验样吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        try {
          const res = await finishVerifyEnd(demandId);
          if (res.code === 200) {
            this.$message.success("操作成功");
            this.refreshList();
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.$message.error(error);
        }
      });
    },
    /** 刷新列表 */
    refreshList() {
      this.pageNum = 1;
      this.orderList = [];
      this.noMore = false;
      this.getMyDemandListFun(this.activeTab);
    },
    /** 删除需求 */
    handleDeleteDemand(item) {
      this.$confirm("确认是否删除？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          try {
            const res = await removeDemand(item.demandId);
            if (res.code == 200) {
              this.$message.success("删除成功");
              this.refreshList();
            } else {
              this.$message.error(res.msg || "删除失败");
            }
          } catch (error) {
            this.$message.error(error.message || "删除失败");
          }
        })
        .catch(() => {});
    },
    /** 打开终止招标弹窗 */
    openTerminateDialog(item) {
      this.currentDemandId = item.demandId;
      this.terminateReason = "";
      this.showTerminateDialog = true;
    },
    /** 关闭终止招标弹窗 */
    closeTerminateDialog() {
      this.terminateReason = "";
    },
    /** 终止招标 - 确定 */
    async handleTerminateConfirm() {
      if (!this.terminateReason || !this.terminateReason.trim()) {
        this.$message.warning("请输入终止理由");
        return;
      }
      try {
        const res = await closeDemand({
          demandId: this.currentDemandId,
          closeExplain: this.terminateReason,
        });
        if (res.code == 200) {
          this.showTerminateDialog = false;
          this.$message.success("已终止招标");
          this.refreshList();
        } else {
          this.$message.error(res.msg || "操作失败");
        }
      } catch (error) {
        console.error("终止招标失败：", error);
        this.$message.error(error.message || "操作失败");
      }
    },
    /** 打开发起订单弹窗 */
    openCreateOrderDialog(item) {
      this.currentDemandId = item.demandId;
      this.currentDemandStatus = item.demandStatus;
      this.resetOrderForm();
      this.orderForm.demandId = item.demandId;
      this.showCreateOrderDialog = true;
    },
    /** 关闭发起订单弹窗 */
    handleCloseCreateOrderDialog() {
      this.showCreateOrderDialog = false;
      this.resetOrderForm();
    },
    /** 重置发起订单表单 */
    resetOrderForm() {
      this.orderForm = {
        demandId: "",
        productName: "",
        productType: "",
        productTypeId: "",
        number: "",
        relationName: "",
        relationPhone: "",
        deliveryTime: "",
        payMethod: "",
        productQuality: "",
        productPicture: [],
        orderInfo: "",
        orderRemark: "",
      };
    },
    /** 提交发起订单 */
    async submitCreateOrder() {
      if (!this.orderForm.productName || !this.orderForm.productName.trim()) {
        this.$message.warning("请填写产品名称");
        return;
      }
      if (!this.orderForm.productTypeId) {
        this.$message.warning("请选择产品类别");
        return;
      }
      if (!this.orderForm.relationPhone || !this.orderForm.relationPhone.trim()) {
        this.$message.warning("请填写联系方式");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.orderForm.relationPhone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }
      try {
        const params = {
          ...this.orderForm,
          number: this.orderForm.number ? Number(this.orderForm.number) : undefined,
          productPicture: Array.isArray(this.orderForm.productPicture) ? this.orderForm.productPicture.join(",") : this.orderForm.productPicture,
        };
        const res = await createDemandOrder(params);
        if (res.code == 200) {
          this.showCreateOrderDialog = false;
          this.$message.success("发起订单成功");
          this.resetOrderForm();
          this.refreshList();
        } else {
          this.$message.error(res.msg || "发起订单失败");
        }
      } catch (error) {
        console.error("发起订单失败：", error);
        this.$message.error(error.message || "发起订单失败");
      }
    },
    /** 获取数据字典 */
    fetchDict() {
      getDictData("app_product_type").then((res) => {
        this.productTypes = (res.data || []).map((item) => ({
          label: item.dictLabel,
          value: item.dictValue,
        }));
      });
    },
  },
  watch: {
    activeTab: function (newVal) {
      // 将 activeTab 同步到路由 query，确保返回页面时能恢复 tab 状态
      if (this.$route.query.route !== newVal) {
        this.$router.replace({
          path: this.$route.path,
          query: { ...this.$route.query, route: newVal },
        });
      }
      this.pageNum = 1;
      this.orderList = [];
      this.noMore = false;
      this.getMyDemandListFun(newVal);
    },
  },
};
</script>

<style>
/* 引入产品需求发布弹窗公共样式 */
@import "~@/assets/css/publish-dialog.css";
</style>

<style scoped>
.info-manage-purchaser {
  background: #ffffff;
  border-radius: 8px;
}

.info-tabs {
  padding: 0 38px;
  position: sticky;
  top: 0;
  background: #ffffff;
  z-index: 10;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.info-manage-purchaser /deep/ .el-tabs__nav-wrap::after {
  height: 0;
}

.info-manage-purchaser /deep/ .el-tabs__header {
  margin: 0;
}
.bar-line {
  width: 100%;
  height: 1px;
  background: #e5e5e5;
  position: sticky;
  top: 60px;
  z-index: 10;
}

.info-tabs >>> .el-tabs__item {
  font-size: 18px;
  color: #999999;
  height: 60px;
  line-height: 60px;
}

.info-tabs >>> .el-tabs__item.is-active {
  color: #1869ff;
  font-weight: 500;
}

.info-tabs >>> .el-tabs__active-bar {
  background-color: #1869ff;
}

/* ========== 订单卡片 ========== */
.order-list {
  padding: 14px 20px;
  max-height: 80vh;
  overflow-y: auto;
}
.order-card {
  margin-top: 16px;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  overflow: hidden;
  font-family: Source Han Sans CN, Source Han Sans CN;
}

.order-card:first-child {
  margin-top: 0;
}

/* 头部 */
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  background: #f7f7f7;
  border-bottom: 1px solid #ebebeb;
  font-size: 14px;
  color: #666666;
}

.header-left {
  display: flex;
  align-items: center;
}

.header-divider {
  margin: 0 12px;
  color: #dcdcdc;
}

.header-status {
  font-size: 14px;
}
.header-status.blue {
  color: #1869ff;
}
.header-status.grey {
  color: #333333;
}

/* 主体 */
.card-body {
  padding: 15px 16px 22px 16px;
  background: #ffffff;
}

.product-name {
  margin-bottom: 4px;
  font-size: 18px;
  font-weight: 400;
  color: #999999;
}

.product-name .label {
  color: #333333;
}

.product-name .value.strong {
  color: #333333;
  font-weight: 500;
}

.product-row {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}

.product-row .label {
  color: #666666;
}

.product-row .value {
  color: #666666;
}

/* 底部 */
.card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 16px;
  background: #ffffff;
  border-top: 1px solid #f0f0f0;
}

.footer-left {
  display: flex;
  align-items: center;
  font-size: 16px;
}

.footer-text {
  color: #333333;
}

.footer-link {
  color: #ff9318;
  cursor: pointer;
}

.footer-right {
  display: flex;
  align-items: center;
}

.action-btn {
  min-width: 80px;
  height: 36px;
  margin-left: 10px;
  background: #ffffff;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  font-size: 16px;
  color: #333333;
  cursor: pointer;
  font-family: inherit;
}

.action-btn:hover {
  color: #1869ff;
  border-color: #1869ff;
}

.loading-more {
  text-align: center;
  padding: 16px 0;
  font-size: 14px;
  color: #999999;
}
</style>
